import { render } from "./ChartBackgroundConfiger.vue?vue&type=template&id=aa2f34bc&scoped=true"
import script from "./ChartBackgroundConfiger.vue?vue&type=script&lang=js"
export * from "./ChartBackgroundConfiger.vue?vue&type=script&lang=js"

import "./ChartBackgroundConfiger.vue?vue&type=style&index=0&id=aa2f34bc&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa2f34bc"]])

export default __exports__